import * as types from "../action/ActionType";
import {  ALL_STATE_INITIAL } from "../store/InitialStore";
export default function AllStateListReducer(
  state = ALL_STATE_INITIAL,
  action
) {
  const { type, payload } = action;
  switch (type) {
    case types.ALL_STATE_LIST:
      return (state = payload);
    default:
      return state;
  }
}
